import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-87768224"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "characters-tabs" }
const _hoisted_2 = { class: "characters-tabs__list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["title", "onClick"]
const _hoisted_5 = { class: "characters-tabs__tab" }
const _hoisted_6 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.characters, (character, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: character.name,
          class: _normalizeClass(["characters-tabs__tab", { 'characters-tabs__tab--current': index === _ctx.current }])
        }, [
          _createElementVNode("button", {
            class: "characters-tabs__button",
            onClick: () => _ctx.changeCharacter(index)
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.shortenName(character.name) || _ctx.$t("new-character")), 1),
            _createElementVNode("button", {
              title: _ctx.$t('ui-close'),
              class: "characters-tabs__remove",
              onClick: () => _ctx.removeCharacter(index)
            }, " x ", 8, _hoisted_4)
          ], 8, _hoisted_3)
        ], 2))
      }), 128)),
      _createElementVNode("li", _hoisted_5, [
        _createElementVNode("button", {
          title: _ctx.$t('new-character'),
          class: "characters-tabs__button characters-tabs__button--new",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewCharacter && _ctx.addNewCharacter(...args)))
        }, " + ", 8, _hoisted_6)
      ])
    ])
  ]))
}